module.exports = __webpack_public_path__ + "cd1e6ef7cda8eaa1aea5ff8f6744d02a.jpg";